var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDeleteSelectTree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.15778 0.947348H11.842C12.3652 0.947348 12.7893 1.37153 12.7893 1.8947V2.84204H5.21033V1.8947C5.21043 1.37153 5.63461 0.947348 6.15778 0.947348ZM4.26308 2.84214V1.8948C4.26308 0.848274 5.11135 0 6.15778 0H11.842C12.8884 0 13.7367 0.848274 13.7367 1.8947V2.84204H16.5788C16.8403 2.84204 17.0525 3.05409 17.0525 3.31572C17.0525 3.57735 16.8403 3.78939 16.5788 3.78939H1.42094C1.15931 3.78939 0.947266 3.57735 0.947266 3.31572C0.947266 3.05409 1.15931 2.84204 1.42094 2.84204H4.26308V2.84214Z",
    fill: "#1A1919"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.15776 15.6316C5.89613 15.6316 5.68408 15.4195 5.68408 15.158V8.05277C5.68408 7.79124 5.89613 7.5791 6.15776 7.5791C6.41939 7.5791 6.63144 7.79124 6.63144 8.05277V15.158C6.63144 15.4195 6.41939 15.6316 6.15776 15.6316Z",
    fill: "#1A1919"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.9998 15.6316C8.73827 15.6316 8.52612 15.4195 8.52612 15.158V8.05277C8.52612 7.79124 8.73827 7.5791 8.9998 7.5791C9.26133 7.5791 9.47347 7.79124 9.47347 8.05277V15.158C9.47347 15.4195 9.26133 15.6316 8.9998 15.6316Z",
    fill: "#1A1919"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8418 15.6316C11.5803 15.6316 11.3682 15.4195 11.3682 15.158V8.05277C11.3682 7.79124 11.5803 7.5791 11.8418 7.5791C12.1034 7.5791 12.3155 7.79124 12.3155 8.05277V15.158C12.3155 15.4195 12.1035 15.6316 11.8418 15.6316Z",
    fill: "#1A1919"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.84204 17.053V5.68461C2.84204 5.42298 3.05408 5.21094 3.31571 5.21094C3.57734 5.21094 3.78939 5.42298 3.78939 5.68461V16.1056C3.78939 16.6289 4.21357 17.053 4.73673 17.053H13.2631C13.7863 17.053 14.2104 16.6289 14.2104 16.1056V5.68461C14.2104 5.42298 14.4225 5.21094 14.6841 5.21094C14.9456 5.21094 15.1577 5.42298 15.1577 5.68461V17.053C15.1577 17.5762 14.7337 18.0003 14.2104 18.0003H3.78939C3.26613 18.0004 2.84204 17.5762 2.84204 17.053Z",
    fill: "#1A1919"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeleteSelectTree);
export default __webpack_public_path__ + "static/media/icon-delete-select-tree.963665d82b6fec392a43d8dc0a62fb25.svg";
export { ForwardRef as ReactComponent };